import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const userRegionIdQuery = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      uuid
      regionId
    }
  }
`

export const userRegionIdKey = getQueryNames(userRegionIdQuery)[0]

export default userRegionIdQuery
